import { render, staticRenderFns } from "./RelatorioMovimentacaoFinanceiraDetalhes.vue?vue&type=template&id=38111793&scoped=true"
import script from "./RelatorioMovimentacaoFinanceiraDetalhes.vue?vue&type=script&lang=js"
export * from "./RelatorioMovimentacaoFinanceiraDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38111793",
  null
  
)

export default component.exports